var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{attrs:{"type":"textarea","value":_vm.value == undefined ? '' : _vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }